import { render } from "./PaidReports.vue?vue&type=template&id=663b4cf9&scoped=true"
import script from "./PaidReports.vue?vue&type=script&lang=js"
export * from "./PaidReports.vue?vue&type=script&lang=js"

import "./PaidReports.vue?vue&type=style&index=0&id=663b4cf9&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2221027770/src/vedicastrologyreport-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-663b4cf9"]])

export default __exports__